// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";

import MainPage from "./pages/MainPage";
import AdminPage from "./pages/AdminPage";
import NewsListPage from "./pages/NewsListPage";
import NewsDetail from "./components/NewsDetail";
import GallerySection from "./components/GallerySection";
import PrivateRoute from "./components/PrivateRoute";

import TrainingPage from "./pages/gallery/TrainingPage";
import ProjectPage from "./pages/gallery/OperationsPage";
import TechnologyPage from "./pages/gallery/ServicePage";
import CertificatePage from "./pages/gallery/CertificatePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";

import "./App.css";

function App() {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  return (
    <MotionConfig reducedMotion={isSafari ? "always" : "never"}>
      <Router>
        <div className="App">
          <Routes>
            {/* 🌍 Halaman utama */}
            <Route path="/" element={<MainPage />} />

            {/* 🔒 Halaman admin (protected) */}
            <Route
              path="/admin"
              element={
                <PrivateRoute>
                  <AdminPage />
                </PrivateRoute>
              }
            />

            {/* 📰 Halaman berita */}
            <Route path="/news" element={<NewsListPage />} />
            <Route path="/news/:id" element={<NewsDetail />} />

            {/* 🖼️ Halaman galeri */}
            <Route path="/gallery" element={<GallerySection />} />
            <Route path="/gallery/training" element={<TrainingPage />} />
            <Route path="/gallery/project" element={<ProjectPage />} />
            <Route path="/gallery/service" element={<TechnologyPage />} />
            <Route path="/gallery/certificate" element={<CertificatePage />} />

            {/* 📝 Privacy Policy */}
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </div>
      </Router>
    </MotionConfig>
  );
}

export default App;
